// @ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';

import { storeProductActivationsAction } from '@/actions/pdcActions';
import { DOWNLOAD_PRODUCT_ACTIVATIONS } from '@/constants';
import fetchProductActivations from '@/fetch/fetchProductActivations';

export function* doDownloadProductActivations() {
    const responseBody = yield call(fetchProductActivations, fetch);
    const items = responseBody?.items || [];

    yield put(storeProductActivationsAction(items));
}

export function* downloadProductActivationsSaga() {
    yield takeLatest(DOWNLOAD_PRODUCT_ACTIVATIONS, doDownloadProductActivations);
}
